import { CircularProgress } from "@mui/material";
import { extractErrorMessage } from "@platform/api";
import { Alert } from "@platform/design-system";

import type { ReactNode } from "react";

/** A case section's state before its rows: still loading, or failed with the API's reason. */
export const SectionStatus = ({
  testId,
  label,
  error,
}: {
  readonly testId: string;
  readonly label: string;
  readonly error: Error | null;
}): ReactNode =>
  error ? (
    <Alert data-testid={`${testId}-error`} severity="error">
      {extractErrorMessage(error, `Failed to load the ${label}`)}
    </Alert>
  ) : (
    <CircularProgress
      data-testid={`${testId}-loading`}
      aria-label={`Loading the ${label}`}
    />
  );
